<template>
	<section class="external-container query-wrap pc-wrap">
		<div>
			<div class="query-title">基本信息</div>
			<ul class="approve-base">
				<li style="width:20.6%"><span>流程ID：</span>{{ approveForm.bizId }}</li>
				<li style="width:12%"><span>劳务工ID：</span>{{ approveForm.emplId }}</li>
				<li style="width:12%"><span>姓名：</span>{{ approveForm.name }}</li>
				<li><span>入职日期：</span>{{ approveForm.entryDate }}</li>
				<li><span>职务：</span>{{ approveForm.jobDescr }}</li>
				<li style="width:20.6%"><span>部门：</span>{{ approveForm.deptName }}</li>
			</ul>
			<div class="query-title">审批详情</div>
			<div class="back-table approve-table">
				<el-table
					:data="approveList"
					style="width: 100%">
					<el-table-column
						prop="nodeName"
						align="center"
						label="阶段">
					</el-table-column>
					<el-table-column
						prop="createDate"
						align="center"
						label="提交时间">
					</el-table-column>
					<el-table-column
						align="center"
						label="工作流状态">
						<template slot-scope="scope">
							<span v-if="scope.row.status=== 'Submited'">提交</span>
							<span v-if="scope.row.status=== 'Approving'">审批中</span>
							<span v-if="scope.row.status=== 'Rejected'">驳回</span>
							<span v-if="scope.row.status=== 'Approved'">已审批</span>
							<span v-if="scope.row.status=== 'Remind'">待办</span>
							<span v-if="scope.row.status=== 'Created'">未提交</span>
							<span v-if="scope.row.status=== 'Completed'">完成</span>
							<span v-if="scope.row.status=== 'Canceled'">已取消</span>
						</template>
					</el-table-column>
					<el-table-column
						align="center"
						prop="name"
						label="当前处理人">
						<!-- <template slot-scope="scope">
							<span>{{ scope.row.currentDeal.name }}({{ scope.row.currentDeal.empId }})</span>
						</template> -->
					</el-table-column>
					<el-table-column
						align="center"
						prop="apvDate"
						label="完成时间">
					</el-table-column>
					<el-table-column
						align="center"
						prop="remark"
						label="审批意见">
					</el-table-column>
					<el-table-column
						label="操作"
						align="center"
						width="100">
						<template slot-scope="scope">
							<span class="detail-link" v-if="scope.row.nodeName === '发起'"><a @click="goToApply(scope.row)">查看详情</a></span>
							<span class="detail-link" v-else-if="scope.row.nodeName === '背景调查'">查看详情</span>
							<span class="detail-link" v-else><a @click="checkDetail(scope.row)" >查看详情</a></span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</section>
</template>

<script>

import { getApprove, getDetailUrl } from '../../network'

export default {
	data() {
		return {
			approveForm: {
				bizId: '',
				taskId: '',
				emplId: '',
				name: '',
				apvDate: '',
				jobDescr: '',
				deptName: '',
			},
			approveList: [],
		}
	},
	watch: {
		
	},
	created() {
		this.getApprove()
		document.title = '外部用工审批详情'
	},
	methods: {
		/* 获取审批历史 */
		getApprove() {
			let params = {
				bizId: this.$route.query.bizId
			}
			return getApprove(params).then((res) => {
				let data = res.data
				this.approveForm = data.data
				this.approveList = this.approveForm.labourFlowAprRespDTOList
			}).catch((error)=>{
				//this.$message.error(JSON.stringify(error))
			})
		},
		// 跳转用工详情
		goToApply(){
			let routeData = this.$router.resolve({
				name: 'ExternalApply',
				query: {
					bizId: this.approveForm.bizId,
				}
			})
			window.open(routeData.href, '_blank');
		},
		// 跳转指定的url
		checkDetail(item){
			let params = {
				applyId: this.approveForm.applyId || '',
				taskId: item.taskId || '',
				status: item.status || '',
			}
			getDetailUrl(params).then((res) => {
				let data = res.data
				if(data.code === 'S00000'){
					let backUrl = data.data || ''
					window.open(backUrl, '_blank')
				}
			}).catch((error)=>{
				//this.$message.error(JSON.stringify(error))
			})
		},
	},

};

</script>
<style lang="scss">
	.approve-base{
		font-size: 0;
		padding-left:25px;
		width: 100%;
		box-sizing: border-box;
		li{
			font-size: 14px;
			display: inline-block;
			color: #424B58;
			width: 16.66%;
			span{
				font-size:14px;
				color: #9298A8;
			}
		}
	}
	.approve-table{
		margin-bottom: 60px;
		padding:0 25px;
		.detail-link{
			color: #9298A8;
			a{
				color: #05B555;
				cursor: pointer;
			}
		}
	}
</style>
